module.exports = __webpack_public_path__ + "static/media/complete-download.e7ecabe5.png";